import "./App.css";
import { Timer, Settings } from "./components";
import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/settings" element={<Settings />} />
        <Route path="/" element={<Timer />} />
      </Routes>
    </div>
  );
}

export default App;
